import { render } from "./PostInstall.vue?vue&type=template&id=99aaf482&scoped=true"
import script from "./PostInstall.vue?vue&type=script&lang=js"
export * from "./PostInstall.vue?vue&type=script&lang=js"

import "./PostInstall.vue?vue&type=style&index=0&id=99aaf482&scoped=true&lang=scss"

import exportComponent from "/tmp/b7562a83-daa0-4796-bff7-c3f4922e39c8/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99aaf482"]])

export default __exports__